/**
 * Coach workout (client view) – get single workout by id for display.
 */
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase/config';

const COLLECTION = 'coachWorkouts';

export async function getById(workoutId) {
  const ref = doc(db, COLLECTION, workoutId);
  const snap = await getDoc(ref);
  if (!snap.exists()) return null;
  return { id: snap.id, ...snap.data() };
}

export const coachWorkoutRepo = { getById };
